import { filter, tap } from 'rxjs/operators';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifyUserService } from '@shared/notify-user.service';

@Component({
    selector: 'fb-dialog-ricalcola-con-ticket',
    templateUrl: './dialog-ricalcola-con-ticket.component.html',
    styleUrls: ['./dialog-ricalcola-con-ticket.component.scss'],
})
export class DialogRicalcolaConTicketComponent implements OnInit {
    form: FormGroup;
    hidePassword = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { ordineId: number },
        public dialogRef: MatDialogRef<DialogRicalcolaConTicketComponent>,
            private notifyUserService: NotifyUserService,
        
    ) {
        this.form = new FormGroup({
            ticketId: new FormControl(null, Validators.required),
            password: new FormControl(null, Validators.required),
        });

        // Alias for backward compatibility with callers that expect this name
        (this as any).rinnovaAbbonamentoFormGroup = this.form;

        // Default handler: show a confirmation modal and close returning the values.
        // Callers (like `StoricoOrdiniComponent`) can override `onConfermaRinnovoAbbonamento`
        // to perform authentication and the actual backend call.
        (this as any).onConfermaRinnovoAbbonamento = () => {
            const ticket = this.form.get('ticketId').value;
            const password = this.form.get('password').value;
            this.notifyUserService
                .showConfirmModal(
                    'Conferma ricalcolo',
                    `Questa operazione ricalcolera' la data di fine abbonamento per l'ordine selezionato. Sicuro di voler procedere?`
                )
                .afterClosed()
                .pipe(filter(confirmed => confirmed === true))
                .subscribe(() => this.dialogRef.close({ ticketId: ticket, password: password }));
        };
    }

    ngOnInit(): void {}

    onConferma() {
        // Delegate to the (possibly overridden) handler so callers can control behavior.
        const handler: any = (this as any).onConfermaRinnovoAbbonamento;
        if (typeof handler === 'function') {
            handler();
        } else {
            // Fallback: behave like default handler
            (this as any).onConfermaRinnovoAbbonamento = (this as any).onConfermaRinnovoAbbonamento || (() => this.dialogRef.close());
            (this as any).onConfermaRinnovoAbbonamento();
        }
    }
}
